import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { formatQ, Truck } from '../home/ui';
import { Card, PageHead, Pill, Thumb, BoxIcon, EmptyCard, orderStatus, fecha, orderLabel, gbtn, pbtn, useOrderDetails, useReorder } from '../account/shared';

// Mis pedidos: pestañas por estado sobre la lista que ya cargó el layout.
// El backend filtra por un solo estado; "En proceso" agrupa cuatro, así que
// se filtra aquí.

const TABS = [['', 'Todos'], ['proc', 'En proceso'], ['ok', 'Entregados'], ['no', 'Cancelados']];

const Orders = () => {
    const [tab, setTab] = useState('');
    const { myOrders } = useSelector(state => state.order);
    const lista = myOrders.filter(o => !tab || orderStatus(o.delivery_status).group === tab);
    const details = useOrderDetails(lista.slice(0, 20).map(o => o._id));
    const reorder = useReorder();

    return (
        <section>
            <PageHead title='Mis pedidos' sub='Consulta el detalle, sigue el envío o vuelve a pedir lo mismo.' />

            <div role='tablist' className='flex gap-1 border-b border-[#e8e6e1] mb-[18px] overflow-x-auto overflow-y-hidden'>
                {TABS.map(([k, l]) => (
                    <button key={k} role='tab' aria-selected={tab === k} onClick={() => setTab(k)}
                        className={`px-5 py-[14px] text-[15px] font-bold border-b-[2.5px] -mb-px whitespace-nowrap transition-colors ${tab === k ? 'text-[#1e3a8a] border-[#0891b2]' : 'text-[#64748b] border-transparent hover:text-[#0f172a]'}`}>
                        {l}
                    </button>
                ))}
            </div>

            {lista.length === 0 ? (
                <EmptyCard icon={<BoxIcon className='w-[26px] h-[26px]' />} title='No hay pedidos aquí' text='Cuando hagas un pedido lo verás en esta sección.'>
                    <Link to='/shops' className={pbtn}>Ir a la tienda</Link>
                </EmptyCard>
            ) : lista.map(o => {
                const st = orderStatus(o.delivery_status);
                const det = details[o._id];
                const prods = det?.products || [];
                return (
                    <Card key={o._id} className='mb-3 !p-5'>
                        <div className='flex flex-wrap gap-x-6 gap-y-[10px] items-center pb-[14px] border-b border-[#f1efea] mb-[14px]'>
                            {[['Pedido', orderLabel(o)], ['Fecha', fecha(o.date)], ['Total', formatQ(o.price)]].map(([k, v]) => (
                                <div key={k}>
                                    <div className='text-[11.5px] text-[#64748b] font-semibold uppercase tracking-[.05em]'>{k}</div>
                                    <div className='text-[14px] font-bold text-[#0f172a]'>{v}</div>
                                </div>
                            ))}
                            <span className='ml-auto'><Pill kind={st.kind}>{st.label}</Pill></span>
                        </div>
                        <div className='flex items-center gap-[14px] flex-wrap'>
                            <div className='flex gap-2'>
                                {(prods.length ? prods.slice(0, 3) : [{}]).map((p, i) => <Thumb key={i} src={p.image} />)}
                            </div>
                            <div className='text-[13.5px] text-[#334155] flex-1 min-w-[160px]'>
                                {prods.length
                                    ? <>{prods[0].name}{prods.length > 1 && ` y ${prods.length - 1} más`}</>
                                    : det === null ? 'No pudimos cargar los productos.' : 'Cargando productos…'}
                            </div>
                            <div className='flex gap-2 flex-wrap'>
                                {st.group === 'proc'
                                    ? <Link to={`/dashboard/order/details/${o._id}`} className={gbtn}><Truck className='w-4 h-4' />Seguimiento</Link>
                                    : prods.length > 0 && <button type='button' onClick={() => reorder(det)} className={gbtn}>Volver a pedir</button>}
                                <Link to={`/dashboard/order/details/${o._id}`} className={`${gbtn} !bg-[#1e3a8a] !text-white !border-[#1e3a8a]`}>Ver detalle</Link>
                            </div>
                        </div>
                    </Card>
                );
            })}
        </section>
    );
};

export default Orders;
